import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const LeftNav = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
            clickHandle: PropTypes.func,
            current: PropTypes.number,
        };
        render() {
            const { content, clickHandle, current } = this.props;
            const navLi = content.map((item, index) => {
                if (item.isHide === true) {
                    return null;
                }
                if (index === current) {
                    return (
                        <li key={index} onClick={() => clickHandle(index)} className={styles.current}>
                            {item.title}
                        </li>
                    );
                } else {
                    return (
                        <li key={index} onClick={() => clickHandle(index)}>
                            {item.title}
                        </li>
                    );
                }
                // return (
                //     <li key={index} onClick={() => clickHandle(index)}>
                //         {item.title}
                //     </li>
                // );
            });

            return <ul id="tab1">{navLi}</ul>;
        }
    },
);

export { LeftNav };
export default LeftNav;
